import { render, staticRenderFns } from "./faqMaintain.vue?vue&type=template&id=12456234&"
import script from "./faqMaintain.vue?vue&type=script&lang=js&"
export * from "./faqMaintain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports